@if (show()) {
	<div class="modal-overlay" *transloco="let t" (click)="onOverlayClick($event)">
		<!-- Hidden focus trap to prevent inputs from stealing focus -->
		<div tabindex="0" #focusTrap style="position: absolute; width: 0; height: 0; opacity: 0;"></div>

		<div class="modal-content" [class.light]="surface() === 'light'">
			@if (closable() !== false) {
				<button
					type="button"
					class="close-btn"
					[attr.aria-label]="t('actions.close')"
					(click)="closed.emit()"
				>
					<base-icon [icon]="CloseIcon" [size]="surface() === 'light' ? 20 : 16" />
				</button>
			}

			<div class="modal-title">
				<ng-content select="[modal-title]">
					<!-- Fallback title content or loader -->
				</ng-content>
			</div>

			<div class="modal-body">
				<ng-content select="[modal-body]">
					<!-- Fallback body content or loader -->
				</ng-content>
			</div>

			<div class="modal-footer">
				<ng-content select="[modal-footer]" class="test">
					<!-- Fallback footer content or loader -->
				</ng-content>
			</div>
		</div>
	</div>
}
